import React from 'react';
import { withRouter } from 'react-router-dom';

const About = ({ history }) => {

  history.listen((location, action) => {
    window.scrollTo(0, 0);
  });

  return (
    <div className="about">
      <span className="aboutHeader">About</span>
      <div className="aboutContent">
        <p className="aboutText">
          This app was inspired by a tweet, suggesting 
          twitter needed a save feature (can't find the origin). 
          I wanted to see if I could implement something similar, 
          using tech that I was interested in. This is the result. 
          Thanks for checking it out! 
          <span role="img" aria-label="emoji">🙌 🙌 🙌</span>
        </p>
        <p className="aboutText">If you like to see more of my work, visit my <a href="https://jdeliaportfolio.netlify.com">portfolio</a>.</p>
      </div>
    </div>
  );
};

export default withRouter(About);